// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + "6242dc2074094e0ef90a" + ".js";
};